export const PATH_TYPE = {
  VIDEO:     'video',
  SUBTITLES: 'subtitles',
  AUDIO:     'audio',
  GROWING:   'growing'
};

export const WAVEFORM_ELEMENTS = {
  NIELSEN:     'Nielsen',
  P_FRAME:     'P Frame',
  GOP:         'I, P, B Frames',
  B_FRAME:     'B Frame',
  SCTE_104:    'SCTE-104',
  SCTE_35:     'SCTE-35',
  WAVEFORM:    'Waveform',
  CLIPS:       'Clips',
  ANNOTATIONS: 'Annotations'
};

export const WAVEFORM_MARKS_COLORS = {
  NIELSEN:  '#008000',
  P_FRAME:  '#4d00cc',
  I_FRAME:  '#cccc9a',
  B_FRAME:  '#004dcc',
  SCTE_104: '#0000FF',
  SCTE_35:  '#ff0000',
};

export const GLIM_TIMECODE_SOURCE = {
  name:  'Zero-Based Timecode',
  value: 'Zero-Based Timecode',
  type:  'timecode',
};

export const NPT_TIMECODE_SOURCE = {
  name:  'Normal Play Time',
  value: 'Normal Play Time',
  type:  'timecode',
};

export const BASIC_TELESTREAM_COLOR = '#0099ee'

export const COLOR_PICKER_SWATCHES = [
  [ "#F64038", "#EC1F60", "#009588", "#000000" ],
  [ "#009CEA", "#FFE856", "#FF9529", "#ffffff" ],
  [ "#8ABF57", "#643FB1", "#CDD951" ],
]

// https://developer.apple.com/library/archive/documentation/QuickTime/QTFF/QTFFAppenG/QTFFAppenG.html
export const AUDIO_PRIMING_DELAY_IN_SECONDS = 2112 / 48000;

export const LAYOUT_FLAGS = {
  HEADER_FLAG:       0b00000001,
  FILE_TOOLBAR_FLAG: 0b00000010,
  VIDEO_PLAYER_FLAG: 0b00000100,
  TIMELINE_FLAG:     0b00001000,
  TOP_TABS_FLAG:     0b00010000,
  BOTTOM_TABS_FLAG:  0b00100000
}

export const ACTION_FLAGS = {
  WATCHERS_FLAG:  0b00000001,
  CLIP_LINK_FLAG: 0b00000010,
  CLOSE_FLAG:     0b00000100,
  BROWSE_FLAG:    0b00001000,
  HISTORY_FLAG:   0b00010000
}

export const TAB_IDS = {
  Annotations: 1,
  Audio:       2,
  Clips:       3,
  Frame:       4,
  Inspector:   5,
  Plugins:     6,
  Scopes:      7
}